export default class LocationService {

    constructor() {}

    /**
     * Add a marker to the map when user clicks on the map.
     * Return an array with markers to show on the map.
     */
    addMarker = (location: any, initialMarkers: any[], locationName: string): any[] => {
        let point: any = new google.maps.LatLng(location.lat(), location.lng());
        initialMarkers.push({ title: locationName, position: point });
        return initialMarkers;
    };

    /**
     * Add 8 points around each marker (45 degrees), needed to set and calculate the margin around the area.
     * Return an array with an area with margin.
     */
    addMarginPointsAroundMarker = (locations: any[], marginInMeters: number): any[] => {
        let areaWithMargin: any[] = [];
        locations.forEach(location => {
            let spherical = google.maps.geometry.spherical;
            for (let angle = 0, i = 0; angle < 360; angle += 45, i++) {
                let marker = spherical.computeOffset(location.position, marginInMeters? marginInMeters : 250, angle);
                areaWithMargin.push({lat: marker.lat(), lng: marker.lng()});
            }
        });
        return areaWithMargin;
    };


    /**
     * Calculate the geoFence based on the areaWithMargin.
     * Return an array containing a geoFence that lies around the outer points.
     */
    calculateGeoFence(areaWithMargin: any[]): any[] {
        const convexHullGrahamScan = new ConvexHullGrahamScan();
        areaWithMargin.forEach(item => {
            convexHullGrahamScan.addPoint(item.lng, item.lat);
        });
        return convexHullGrahamScan.getHull().map((item) => {
            return {
                lat: item.y,
                lng: item.x
            };
        });
    }
}

class Point {
    x: any;
    y: any;
    constructor(x: any, y: any) {
        this.x = x;
        this.y = y;
    }
}

/**
 * Typescript implementation of the ConvexHullGrahamScan Algorithm to calculate a geofence around a set of points.
 */
class ConvexHullGrahamScan {
    points: Point[] = [];
    anchorPoint: Point | undefined = undefined;
    reverse = false;

    constructor() {}

    findPolarAngle = (a: any, b: any) => {
        const ONE_RADIAN = 57.295779513082;
        let deltaX, deltaY;
        if (!a || !b) return 0;
        deltaX = (b.x - a.x);
        deltaY = (b.y - a.y);
        if (deltaX === 0 && deltaY === 0) {
            return 0;
        }
        let angle = Math.atan2(deltaY, deltaX) * ONE_RADIAN;
        if (this.reverse) {
            if (angle <= 0) {
                angle += 360;
            }
        } else {
            if (angle >= 0) {
                angle += 360;
            }
        }
        return angle;
    };

    addPoint = (x: any, y: any) => {
        let newAnchor =
            (this.anchorPoint === undefined) ||
            (this.anchorPoint.y > y) ||
            (this.anchorPoint.y === y && this.anchorPoint.x > x);
        if (newAnchor) {
            if (this.anchorPoint !== undefined) {
                this.points.push(new Point(this.anchorPoint.x, this.anchorPoint.y));
            }
            this.anchorPoint = new Point(x, y);
        } else {
            this.points.push(new Point(x, y));
        }
    };

    sortPoints = () => {
        let self = this;
        return this.points.sort(function (a: any, b: any) {
            let polarA = self.findPolarAngle(self.anchorPoint, a);
            let polarB = self.findPolarAngle(self.anchorPoint, b);
            if (polarA < polarB) {
                return -1;
            }
            if (polarA > polarB) {
                return 1;
            }
            return 0;
        });
    };

    checkPoints = (p0: any, p1: any, p2: any) => {
        let difAngle;
        let cwAngle = this.findPolarAngle(p0, p1);
        let ccwAngle = this.findPolarAngle(p0, p2);
        if (cwAngle > ccwAngle) {
            difAngle = cwAngle - ccwAngle;
            return !(difAngle > 180);
        } else if (cwAngle < ccwAngle) {
            difAngle = ccwAngle - cwAngle;
            return (difAngle > 180);
        }
        return true;
    };

    getHull = (): any[] => {
        let hullPoints = [],
            points,
            pointsLength;
        this.reverse = this.points.every(function (point: any) {
            return (point.x < 0 && point.y < 0);
        });
        points = this.sortPoints();
        pointsLength = points.length;
        if (this.anchorPoint !== undefined && pointsLength < 3) {
            points.unshift(this.anchorPoint);
            return points;
        }
        hullPoints.push(points.shift(), points.shift());
        while (true) {
            let p0, p1, p2;
            hullPoints.push(points.shift());
            p0 = hullPoints[hullPoints.length - 3];
            p1 = hullPoints[hullPoints.length - 2];
            p2 = hullPoints[hullPoints.length - 1];
            if (this.checkPoints(p0, p1, p2)) {
                hullPoints.splice(hullPoints.length - 2, 1);
            }
            if (points.length == 0) {
                if (pointsLength == hullPoints.length) {
                    let ap = this.anchorPoint;
                    hullPoints = hullPoints.filter(function (p) {
                        return !!p;
                    });
                    if (!hullPoints.some(function (p) {
                        if (p !== undefined && ap !== undefined) {
                            return (p.x == ap.x && p.y == ap.y);
                        }
                    })) {
                        hullPoints.unshift(this.anchorPoint);
                    }
                    return hullPoints;
                }
                points = hullPoints;
                pointsLength = points.length;
                hullPoints = [];
                hullPoints.push(points.shift(), points.shift());
            }
        }
    };
}


